module.exports = __webpack_public_path__ + "img/inj.6b7f1cf7.svg";